import cn from 'client/utils/cn';

import ReadMore from 'client/components/read-more';
import React, { Component } from 'react';

import './index.css';

const b = cn('about-card');

interface Props {
    label: string;
    description: string;
    image: string;
    url: string;
}

class AboutCard extends Component<Props> {
    render() {
        const { label, description, image, url } = this.props;

        return (
            <div className={b()}>
                <img className={b('image')} src={image} />
                <div className={b('content')}>
                    <h2 className={b('title')}>{label}</h2>
                    <p
                        className={b('description')}
                        dangerouslySetInnerHTML={{ __html: description }}
                        />
                    <ReadMore className="about-card__link" link={url} />
                </div>
            </div>
        );
    }

}

export default AboutCard;
